import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import {
//   CommonModule,
//   LocationStrategy,
//   HashLocationStrategy
// } from '@angular/common';
import {CommonModule, LocationStrategy, Location, PathLocationStrategy, HashLocationStrategy} from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';

// import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { KycComponent } from './layouts/kyc/kyc.component';
import { AdminComponent } from './layouts/admin/admin.component';

import { NavigationComponent } from './shared/header-navigation/navigation.component';
// import { SidebarComponent } from './shared/banker_sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { KycSidebarComponent } from './shared/kyc_sidebar/kycsidebar.component';
import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// sweetalert
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
// BUYER
import { BuyerComponent } from './layouts/buyer/buyer.component';
import { BuyerSidebarComponent } from './shared/buyer_sidebar/buyersidebar.component';
// SELLER
import { SellerComponent } from './layouts/seller/seller.component';
import { SellerSidebarComponent } from './shared/seller_sidebar/sellersidebar.component';
// BANKER
import { BankerComponent } from './layouts/banker/banker.component';
import { BankerSidebarComponent } from './shared/banker_sidebar/bankersidebar.component';
// SERVICES
import { AuthenticationService } from './services/authentication.service';
import { KycService } from './services/kyc.service';
import { GlobalService } from './services/global.service';
import { BuyerMRService } from './services/buyer/material-request.service';
import { SellerMRService } from './services/seller/material-request.service';
import { SellerPIService } from './services/seller/proforma-invoice.service';
import { BuyerPIService } from './services/buyer/proforma-invoice.service';
import { BuyerPOService } from './services/buyer/purchase-order.service';
import {BuyerInvoiceService} from './services/buyer/invoice.service';

import { SellerInvoiceService } from './services/seller/invoice.service';
import { SellerPOService } from './services/seller/purchase-order.service';
import { SellerInvoiceDiscountingService } from './services/seller/invoice-discounting.service';
import { BuyerDashboardService } from './services/buyer/buyer-dashboard.service';
import { SellerDashboardService } from './services/seller/seller-dashboard.service';
import { SellerBOEService } from './services/seller/boe.service';
import { BuyerBOEService } from './services/buyer/boe.service';
import { BankerBillsService } from './services/banker/bills.service';
import { BankerDshboardService } from './services/banker/banker-dshboard.service';
import { BuyerHeaderComponent } from './shared/buyer-header/buyer-header.component';
import { BankerHeaderComponent } from './shared/banker-header/banker-header.component';
import { KYCHeaderComponent } from './shared/kyc-header/kyc-header.component';
import { AdminHeaderComponent } from './shared/admin-header/admin-header.component';

import { ToastrModule } from 'ngx-toastr';

import { AuthGuardService } from './auth-guard.service';
import { AuthService } from './auth.service';
import { JwtModule } from '@auth0/angular-jwt';

import { BlockExplorerService } from './services/blockExplorer.service';
// FCM
import {MessagingService} from './shared/messaging.service';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { from } from 'rxjs';
import { HttpModule } from '@angular/http';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { jqxChartModule } from 'jqwidgets-ng/jqxchart';
import { UwBankerComponent } from './layouts/uw-banker/uw-banker.component';
import { UwBankerHeaderComponent } from './shared/uw-banker-header/uw-banker-header.component';
import { UwBankerSidebarComponent } from './shared/uw-banker-sidebar/uw-banker-sidebar.component';
import { AdminSidebarComponent } from './shared/admin-sidebar/admin-sidebar.component';
// sales
import { SalesComponent } from './layouts/sales/sales.component';
import { SalesHeaderComponent } from './shared/sales-header/sales-header.component';
import { SalesSidebarComponent } from './shared/sales-sidebar/sales-sidebar.component';
import { ChannelLayoutComponent } from './layouts/channel/channel-layout/channel-layout.component';
import { ChannelHeaderComponent } from './shared/channel-header/channel-header.component';
import { ChannelSidebarComponent } from './shared/channel-sidebar/channel-sidebar.component';
import { RmComponent } from './admin/rm/rm.component';
import { RmModule } from './admin/rm/rm.module';
// import { RmDashboardComponent } from './rm/rm-dashboard/rm-dashboard.component';
import { RMAnchorComponent } from './rm/anchor/anchor.component';
import { RMCounterPartyComponent } from './rm/counter-party/counter-party.component';
import { RmLayoutComponent } from './layouts/rm-layout/rm-layout.component';
import { RmOnboardingComponent } from './rm/rm-onboarding/rm-onboarding.component';
import { RmHeaderComponent } from './shared/rm-header/rm-header.component';
import { RmSidebarComponent } from './shared/rm-sidebar/rm-sidebar.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PdfReaderService } from './services/pdf-reader.service';
import { OrderModule } from 'ngx-order-pipe';
import { ManualBankerBillsService } from './services/banker/manual-bills.service';
import { ManualSuperAdminService } from './services/manual-super-admin.service';
import { SuperAdminSubjectService } from "./services/admin/super-admin.service";
import { BuyerAgreementService } from './services/buyer/agreement.service';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};
export function tokenGetter() {
  return localStorage.getItem('currentUser');
}
@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    // FullComponent,
    BlankComponent,
    KycComponent,
    AdminComponent,
    NavigationComponent,
    BreadcrumbComponent,
    // SidebarComponent,
    KycSidebarComponent,
    BuyerComponent,
    BuyerSidebarComponent,
    SellerComponent,
    SellerSidebarComponent,
    BankerComponent,
    BankerSidebarComponent,
    BuyerHeaderComponent,
    BankerHeaderComponent,
    KYCHeaderComponent,
    AdminHeaderComponent,
    UwBankerComponent,
    SalesComponent,
    UwBankerHeaderComponent,
    UwBankerSidebarComponent,
    AdminSidebarComponent,
    SalesHeaderComponent,
    SalesSidebarComponent,
    ChannelLayoutComponent,
    ChannelHeaderComponent,
    ChannelSidebarComponent,
    // RmDashboardComponent,
    // RMAnchorComponent,
    // RMCounterPartyComponent,
    RmLayoutComponent,
    // RmOnboardingComponent,
    RmHeaderComponent,
    RmSidebarComponent,
    // RmComponent
  ],
  imports: [
    jqxChartModule,
    HttpModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    ToastrModule.forRoot(),
    NgbModule.forRoot(),
    SweetAlert2Module.forRoot(),
    SlimLoadingBarModule.forRoot(),
    RouterModule.forRoot(Approutes, { useHash: false, anchorScrolling: 'enabled' }),
    PerfectScrollbarModule,
    Ng2SearchPipeModule,
    OrderModule,
    
    // RmModule,
    // AdminHeaderModule,
  
    // AdminLayoutModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: ['example.com'],
        blacklistedRoutes: ['example.com/examplebadroute/']
      }
    })
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy
    // },

    // {provide: LocationStrategy, useClass: HashLocationStrategy},
    AuthenticationService,
    KycService,
    GlobalService,
    BuyerMRService,
    SellerMRService,
    SellerPIService,
    BuyerPIService,
    BuyerPOService,
    BuyerInvoiceService,
    SellerPOService,
    SellerInvoiceService,
    BuyerAgreementService,
    SellerInvoiceDiscountingService,
    SellerBOEService,
    BuyerBOEService,
    BankerBillsService,
    ManualBankerBillsService,
    BankerDshboardService,
    AuthGuardService,
    AuthService,
    BuyerDashboardService,
    ManualSuperAdminService,
    SellerDashboardService,
    BlockExplorerService,
    MessagingService,
    AsyncPipe,
    SuperAdminSubjectService
    // PdfReaderService
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
